export const ICON_SM = "/images/icon-sm.png";
export const ICON_MD = "/images/icon-md.png";
export const ICON_LG = "/images/icon-lg.png";
export const HERO_IMG = "/images/hero.jpg";
